<script setup lang="ts">
  import logoImg from '../assets/logo-signaltone.png';

  const HOME_URL = 'https://www.signaltone.com.cn/index.html';
</script>

<template>
  <header class="download-header">
    <div class="header-inner">
      <a
        class="brand"
        :href="HOME_URL"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img class="brand-logo" :src="logoImg" alt="信路通"/>
      </a>
      <nav class="nav">
        <a
          class="nav-item"
          :href="HOME_URL"
          target="_blank"
          rel="noopener noreferrer"
        >首页</a>
        <span class="nav-item is-active">资源下载</span>
      </nav>
    </div>
  </header>
</template>

<style scoped lang="scss">
  .download-header {
    position: sticky;
    top: 0;
    z-index: 20;
    background: #fff;
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
  }

  .header-inner {
    max-width: 1200px;
    margin: 0 auto;
    height: 64px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .brand {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
  }

  .brand-logo {
    height: 40px;
    width: auto;
    display: block;
  }

  .nav {
    display: flex;
    align-items: center;
    gap: 28px;
  }

  .nav-item {
    font-size: 15px;
    color: #4b5563;
    text-decoration: none;
    line-height: 1;

    &:hover {
      color: #1677ff;
    }

    &.is-active {
      color: #1677ff;
      font-weight: 600;
    }
  }
</style>
